import { useMemo } from 'react';
import { useStyleCategoriesQuery } from 'src/hooks/style-categories/queries/useStyleCategoriesQuery';
import { BuyingEvent, mapOpenToBuyLimitToTableData } from 'src/mapping/open-to-buy-limit.mapping';
import { useOpenToBuyLimitQuery } from '../queries/useOpenToBuyLimitQuery';

export const useOpenToBuyLimitOverviewRows = () => {
    const {
        data: styleCategories,
        error: styleCategoriesError,
        loading: styleCategoriesLoading,
    } = useStyleCategoriesQuery();
    const { data, plannedOn, buyingEvents, loading, error } = useOpenToBuyLimitQuery();
    const { rows: tableData, columns } = useMemo(
        () => mapOpenToBuyLimitToTableData(data, buyingEvents, plannedOn, styleCategories),
        [buyingEvents, data, plannedOn, styleCategories]
    );

    const mappedBuyingEvents = buyingEvents?.reduce<BuyingEvent[]>((acc, event) => {
        if (event?.id) {
            acc.push({
                id: event.id,
                name: event.name,
                orderMonth: event.orderMonth,
                buyingStart: event.buyingStart,
                buyingEnd: event.buyingEnd,
                isDefault: event.isDefault,
            });
        }
        return acc;
    }, []);

    return {
        data: tableData,
        buyingEvents: mappedBuyingEvents,
        columns,
        plannedOn,
        error: error ?? styleCategoriesError,
        loading: loading || styleCategoriesLoading,
    };
};
